import ConfigsModule from '../../../configs/configs';
import ResourcesModule from '../../../resources/resources';
import ServicesModule from '../../../services/services';
import template from './fieldConfigsForm.jade';

export class FieldConfigsFormController {
  /* @ngInject */
  constructor($filter) {
    this.translate = $filter('translate');

    this.fields = [
      {
        className: 'layout__item u-1/4',
        type: 'input',
        key: 'field_name',
        expressionProperties: {
          "templateOptions.disabled": "model.disabled"
        },
        templateOptions: {
          label: this.translate('field_name'),
          required: true
        }
      },
      {
        className: 'layout__item u-2/4',
        type: 'input',
        key: 'field_label',
        templateOptions: {
          label: this.translate('field_label'),
          required: true
        }
      },
      {
        className: 'layout__item u-1/4',
        type: 'uiSelect',
        key: 'field_type',
        expressionProperties: {
          "templateOptions.disabled": "model.disabled"
        },
        templateOptions:{
          label: this.translate('field_type'),
          options: 'integer date string bool decimal'.split(/\s+/).map((value) => {
            return {value, name: this.translate(value)}
          }),
          required: true
        }
      },
      {
        className: 'layout__item u-1/1',
        type: 'uiSelectMultiple',
        key: 'semantics',
        templateOptions:{
          label: this.translate('semantics'),
          help: this.translate('semantics_help'),
          options: 'count_lifetime count_by_range_breakdown sum_lifetime sum_by_range_breakdown swap flip append'.split(/\s+/).map((value) => {
            return {value, name: value}
          }),
          required: true,
          onChange: (($viewValue,$modelValue,$scope) => {
            this.updateSemanticsValue($modelValue || $viewValue);
          })
        }
      },
      {
        className: 'layout__item u-1/1',
        type: 'uiSelectMultiple',
        key: 'comparisons',
        templateOptions:{
          label: this.translate('comparisons'),
          help: this.translate('comparisons_help'),
          options: '$gt	$gte $lt $lte $eq $ne $in $nin $in_last_days $nin_last_days $exists $between'.split(/\s+/).map((value) => {
            return {value, name: value}
          }),
          required: true,
          onChange: (($viewValue,$modelValue,$scope) => {
            this.updateComparisonsValue($modelValue || $viewValue);
          })
        }
      },
      {
        className: 'layout__item u-1/1',
        type: 'uiSelect',
        key: 'possible_values_population',
        templateOptions:{
          label: this.translate('possible_values_population'),
          options: 'dynamic fixed'.split(/\s+/).map((value) => {
            return {value, name: `${value} - ` + this.translate(`$fieldConfig.possible_values_population.${value}`)};
          }),
          required: true
        }
      },
      {
        className: 'layout__item u-1/1',
        type: 'uiSelectMultipleTagging',
        key: 'possible_values',
        hideExpression: 'model.possible_values_population !== "fixed"',
        templateOptions:{
          label: this.translate('possible_values'),
          options: [],
          required: true
        }
      },
      {
        className: 'layout__item u-1/2',
        type: 'checkbox',
        key: 'for_personalization',
        templateOptions:{
          label: this.translate('for_personalization')
        }
      },
      {
        className: 'layout__item u-1/2',
        type: 'checkbox',
        key: 'for_encryption',
        templateOptions:{
          label: this.translate('for_encryption')
        }
      }
    ]
  }

  invalidSemanticsValues(field_type, value) {
    let oringValue = _.clone(value);

    // sum_lifetime/by_range_breakdown - available only if field is integer/decimal (otherwise cannot be summed)
    if (!_.includes(['integer', 'decimal'], field_type)) {
      value = _.without(value, 'sum_lifetime', 'by_range_breakdown');
    }

    // swap,flip,append - each one must be alone - any combination of one of these that is greater than one is not valid.
    let swapFlipAppendIntersection = _.intersection(value, 'swap flip append'.split(/\s+/));
    if (swapFlipAppendIntersection.length) {
      value = swapFlipAppendIntersection.slice(0,1);
    }

    // counters/sum - lifetime/by_range_breakdown - only valid combinations are count+ count or sum+sum
    let hasPrefix = (prefix) => {
      return ((value) => value.toString().match(new RegExp(`^${prefix}`)));
    };
    let countValues = _.filter(value, hasPrefix('count'));
    let sumValues = _.filter(value, hasPrefix('sum'));
    if (countValues.length && sumValues.length) {
      value = _.reject(value, hasPrefix('sum'));
    }

    return _.difference(oringValue, value);
  }

  invalidComparisonsValues(field_type, value) {
    let oringValue = _.clone(value);

    if (field_type == 'bool') {
      // if type is bool than only $eq allows (true/false)
      value = _.intersection(value, ['$eq']);
    } else if (!_.includes(['integer', 'decimal'], field_type)) {
      // all quantative ($gt,$lt,$eq...) can be defined only on field type integer/decimal
      value = _.without(value, '$eq', '$gt', '$gte', '$lt', '$lte', '$ne', '$between');
    }

    if (!_.includes(['integer', 'decimal', 'string'], field_type)) {
      // $in, $nin can be defined on field type integer/decimal/string
      value = _.without(value, '$in', '$nin');
    }

    if (!_.includes(['integer', 'decimal', 'date'], field_type)) {
      // $in_last_days, $nin_last_days can be defined on field type integer/decimal/date
      value = _.without(value, '$in_last_days', '$nin_last_days');
    }

    // $exists can only be defined on string field types
    if (field_type != 'string') {
      value = _.without(value, '$exists');
    }

    return _.difference(oringValue, value);
  }

  updateSemanticsValue(value) {
    if (value.length) {
      this.resource.semantics = _.difference(value, this.invalidSemanticsValues(this.resource.field_type, this.resource.semantics));
    }
  }

  updateComparisonsValue(value) {
    if (value.length) {
      this.resource.comparisons = _.difference(value, this.invalidComparisonsValues(this.resource.field_type, this.resource.comparisons));
    }
  }
}

export function FieldConfigsFormComponent() {
  return {
    template,
    controller: FieldConfigsFormController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      resource: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.admin.fieldConfigs.form', [
    ConfigsModule.name,
    ResourcesModule.name,
    ServicesModule.name
])
  .directive('fieldConfigsForm', FieldConfigsFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/admin/games/fieldConfigsForm.js
 **/